//
// gallery
//////////////////////////////////////////////////////////////////////
var swiperGallery = new Swiper ('#section_gallery .swiper-container', {
  centeredSlides: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  speed: 500,
  slidesPerView: 1,
  spaceBetween: 15,
  pagination: {
    el: '#section_gallery .slide-counter .text',
    type: 'fraction',
  },
  breakpoints: {
    767: {
      spaceBetween: 10,
    }
  },
});

//
// overview
//////////////////////////////////////////////////////////////////////
$(window).on("load", function(){
  var widthWindow = $(window).width,
      bgHideHeight = windthWindow = 767 ? 150 : 80; 
      $readMore = $("#section_overview .read-more"),
      heightReadMore = $readMore.outerHeight(),
      $bgReadMore = $("#section_overview .bg_read-more");

  if(heightReadMore <= bgHideHeight) {
    $bgReadMore.hide();
  }
});

//
// property info
//////////////////////////////////////////////////////////////////////
$(function(){
  var $btn = $("#section_property-info .btn_view-all"),
      $list = $("#section_property-info .list_info"),
      classShow = "show";

  $btn.click(function() {
    $(this).toggleClass(classShow);

    if($(this).hasClass(classShow)) {
      $(this).prev().find(".hide").slideDown();
    } else {
      $(this).prev().find(".hide").slideUp();
    }
  });
});

// マップ
////////////////////////////////////
$(window).on("load",function(){
  initMap();
});

function initMap() {
  var myOptions = {
    scrollwheel: false, // スクロールを無効化
    streetViewControl:false, // ストリートビューを表示させない
    mapTypeControl: false,
    fullscreenControl: false,
    mapTypeControlOptions: { mapTypeIds: ['style', google.maps.MapTypeId.ROADMAP] }, // 表示タイプの指定
    zoomControlOptions: { position: google.maps.ControlPosition.TOP_LEFT },
    gestureHandling: 'greedy',
    minZoom : 11,
    maxZoom : 17
  };
  var map = new google.maps.Map(document.getElementById('map'), myOptions);
  var styleOptions = [
    {
      "featureType": "administrative.land_parcel",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.neighborhood",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi.attraction",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi.business",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi.government",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi.medical",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi.place_of_worship",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi.school",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi.sports_complex",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    }
  ];
  var styledMapOptions = { name: '物件詳細' } // 地図左上のタイトル
  var originalType = new google.maps.StyledMapType(styleOptions, styledMapOptions);
  map.mapTypes.set('style', originalType);
  map.setMapTypeId('style');
  // マーカー生成
  var bounds = new google.maps.LatLngBounds(); // マーカーに合わせてマップセンターを移動
  var lat = parseFloat(markerData.lat),
      lng = parseFloat(markerData.lng);
  markerLatLng = new google.maps.LatLng({ lat: lat, lng: lng }); // 緯度経度のデータ作成
  var host = location.host;
  if(host.indexOf('re-ism') != -1) {
    var pathMarker = "/wp/wp-content/themes/reism-theme-v261022/assets/img/common/icon_pin_orange.svg"; // マーカー画像のパス（WordPress）
  } else {
    var pathMarker = "/assets/img/common/icon_pin_orange.svg"; // マーカー画像のパス（静的デモ）
  }
  marker = new google.maps.Marker({
    // マーカーの追加
    map: map, // マーカーを立てる地図を指定
    position: markerLatLng, // マーカーを立てる位置を指定
    icon: new google.maps.MarkerImage(
      pathMarker,
      new google.maps.Size(30,30),
      new google.maps.Point(0,0),
      new google.maps.Point(15,15)
    )
  });
  map.setCenter(new google.maps.LatLng(lat, lng));
  map.setZoom(16); // マーカーに合わせてマップセンターを移動

  var cityCircle = new google.maps.Circle({
    strokeWeight: 0,
    fillColor: '#FF5800',
    fillOpacity: 0.30,
    map: map,
    center: new google.maps.LatLng(lat, lng),
    radius: 100
  }); 
}

//
// modal initial cost
//////////////////////////////////////////////////////////////////////

// modal button
////////////////////////////////////
$(function(){
  var $btnOpen = $("#section_rent .btn_modal"),
      $modal = $("#modal_initial-cost"),
      classShow = "show",
      classActive = "active";

  // modal open
  $btnOpen.click(function() {
    var widthWindow = $(window).width();

    if(widthWindow >= 768) {  // PCレイアウト（モーダル）
      $(this).addClass(classShow);
      $modal.fadeIn();
      addActiveClassModal();
      bodyScrollLock();
    } else {                  // SPレイアウト（アコーディオン）
      $(this).toggleClass(classShow);

      if($(this).hasClass(classShow)) {
        $modal.slideDown();
        addActiveClassModal();  // ブラウザリサイズ対策
      } else {
        $modal.slideUp();
        removeActiveClassModal(); // ブラウザリサイズ対策
      }
    }
  });

  // modal close
  $("#modal_initial-cost .btn_close, #modal_initial-cost .overlay").click(function() {
    $modal.fadeOut();
    bodyScrollRelease();
    $btnOpen.removeClass(classShow);  // ブラウザリサイズ対策
    removeActiveClassModal();
  });

  // ブラウザリサイズ対策
  $(window).on("resize",function(){
    var widthWindow = $(window).width();

    if(widthWindow <= 767) {
      $("body").removeClass("body_fixed");
      $("body").removeAttr("style");
    }
  });

  // function
  function addActiveClassModal() {
    $modal.addClass(classActive);
  }

  function removeActiveClassModal() {
    $modal.removeClass(classActive);
  }
});

//
// report
//////////////////////////////////////////////////////////////////////

// swiper
////////////////////////////////////
var swiperReport = new Swiper ('#section_report .swiper-container', {
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  speed: 500,
  slidesPerView: 2.65,
  spaceBetween: 5,
  breakpoints: {
    929: {
      slidesPerView: 2.2,
      spaceBetween: 5
    },
    767: {
      slidesPerView: 1,
      spaceBetween: 0
    }
  },
});

// index
////////////////////////////////////
$(function(){
  var $list = $("#section_report .item_list_report"),
      $current = $list.find(".index .current"),
      $length = $list.find(".index .length"),
      $lengthSp = $list.find(".index_sp .length"),
      length = $list.length,
      $indexSp = $list.find(".index_sp");

  $length.text(length);
  $lengthSp.text(length);

  $list.each(function(index) {
    index = length - index;
    $(this).find(".current").text(index);
  });

  // sp
  $(window).on("load resize", function() {
    var heightBoxDetail = $list.find(".box_detail").outerHeight();
    $indexSp.css('bottom', heightBoxDetail / 2 + 15);
  });
});


// detail box
////////////////////////////////////
$(window).on("load resize", function() {
  $("#section_report .item_list_report .box_detail").tile();
});

//
// lifestyle
//////////////////////////////////////////////////////////////////////
// $(function() {
//   $(window).on("load resize", function() {
//     $("#section_lifestyle .item_list_lifestyle .ttl").tile();
//     $("#section_lifestyle .item_list_lifestyle .description").tile();
//   });
// });

// visit button
//////////////////////////////////////////////////////////////////////
$(window).on("load resize scroll", function(){
  var scrollTop = $(window).scrollTop(),
      heightWindow = window.innerHeight,
      bottomWindow = heightWindow + scrollTop,
      topSearchAssistance = $("#block_search-assistance").offset().top,
      topSearchAssistance2 = $("#section_gallery").offset().top,
      $btnVisit = $("#block_btn_visit"),
      classFixed = "fixed",
      classVisible = "visible";

  if (scrollTop >= topSearchAssistance2) {
    $btnVisit.addClass(classVisible);
  } else {
    $btnVisit.removeClass(classVisible);
  }
  /*
  if(bottomWindow >= topSearchAssistance) {
    $btnVisit.removeClass(classFixed);
  } else {
    $btnVisit.addClass(classFixed);
  }
  */
});
